import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

export const InfoPanel = () => {
  const { t } = useTranslation()
  return (
    <Panel>
      <Item>{t('infoPanelRule1')}</Item>
      <Item>{t('infoPanelRule2')}</Item>
      <Item>{t('infoPanelRule3')}</Item>
      <Item>{t('infoPanelRule4')}</Item>
    </Panel>
  )
}

const Panel = styled.ul`
  position: absolute;
  border: 1px;
  padding: 26px 26px 26px 46px;
  background: #01a8e7;
  border-radius: 5px;
  z-index: 20;
`
const Item = styled.li`
  padding: 5px 0;
  color: white;
  font-size: 12px;
`
